<div *ngIf="tendenz" class="container">
  Tendenz:
  <mat-icon matTooltip="{{tendenz.wertAsString}}">{{determineIconName(tendenz.wert)}}</mat-icon>
</div>
